import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';

import CustomerOrder from '../../components/customersuccessportal/CustomerOrder';

import './CustomerOrderHistory.css';

import Api from '../../utils/api';

class CustomerOrderHistory extends Component {
    constructor(props){
        super(props);

        this.state = {
            email: '',
            noData: false,
            loadingDone: false,
            orders: []
        };

    }


    componentDidMount() {
        this.getCustomerOrderHistory(function() {
            if (this.state.orders.length === 0) this.setState({ noData: true });
            return;
        });
        
    }

    getCustomerOrderHistory(callback) {
        const userId = this.props.id;
        fetch('/api/user-orders/extended-with-products?user-id=' + userId, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': Api.auth_tokenManager()
            }
        }).then((response) => response.json()).then(responseJson => {
            this.setState({ 
                orders: responseJson, 
                loadingDone: true 

            });
        }).catch(function(err) {
            alert("There was a problem getting the order history: " + err);
        });
    }

    renderOrders() {
        const orders = this.state.orders.length > 0 ?
        this.state.orders.map(
            (order, index) => 
            <CustomerOrder 
                onOpenRegimenModal={ this.props.onOpenRegimenModal }
                getSelectedOrderForRegimenCard={ this.props.getSelectedOrderForRegimenCard }
                key={ index } 
                order={ order } 
            />
        ) :
        "No products found."

        return orders;
    }

    render() {
        return (

            <div className="user-orders">
                {   
                    this.state.loadingDone ?
                    this.renderOrders() :
                    <div className="loading">Retrieving order history...</div>
                }
            </div>

        );
    }
}

export default withRouter(CustomerOrderHistory);



// WEBPACK FOOTER //
// ./src/views/customersuccessportal/CustomerOrderHistory.js